// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"63b833770c66f700","7515":"4448b9388ee00483","7879":"8dcd405181707606"}[chunkId] + ".css";
};